import { createContext } from "react";
import { AuthProvider } from "./AuthProvider";

export const AuthContext = createContext(AuthProvider);